import {
    createColumnInlineInputNumber,
    createColumnInput,
    createColumnSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { createManageDelete, createManageExportCsv, createPage } from "../../../../utils/page";
import { has } from "../../../../utils/menu-context";
import { onClickDeleteAllClient } from "../../../../utils/form";
import lodash from "lodash";
import { openModalList as openModalListCompanyProduct } from "../../company/company-product/company-product.logic";
import { openModalList as openModalListSamplingProduct } from "../../sampling/sampling-product/sampling-product.logic";
import { createButtonCreate } from "../../../../utils/button";
import { onIFrameClickSelectAll } from "../../../../utils/iframe";
import { createLoading } from "../../../../utils/loading";
import store from "../../../../store";
import { validateError } from "../../../../utils/validate";
import {defineAsyncComponent, toRaw} from "vue";
import { checkTooltipLabel } from "../certificate-request/certificate-request.section";
import { callGetSumExportAmount } from "../certificate-request/certificate-request.logic";

export const CIcon = defineAsyncComponent(() => import('../../../../components/icon/CIcon'))
export const { isLoading, setIsLoading } = createLoading()
export const callStatusRequest = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'CERTIFICATE_REQUEST_STATUS', value: searchQuery, options: { force: true } })

export const createColumns = ( { props, data }) => {
    const { visibleSamplingNo, visibleProductCode, visibleProductNameEn, visibleSamplingProductNameTh, visiblePackageSize, visibleExportAmount, visibleBalanceAmount,
        visibleExportCountry, visibleSamplingProducts, visibleCompanyProducts, isTablePackaging, viewOnly, itemsKey } = props
    const { useForm } = data
    const { modelRef } = useForm
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef
    const columns = []
    if (visibleSamplingProducts) {
        if (visibleSamplingNo) {
            columns.push(createColumnInput({
                title: () => i18n.global.t("model.samplingProduct.samplingNo"),
                dataIndex: "refSamplingProduct.samplingNo",
                align: 'center',
                customRender: ({ record, column }) => checkTooltipLabel({ field: column,  labelTitle: record.refSamplingProduct?.samplingNo, parentModel: record.refParent, model: record }),
            }))
        }
        if (visibleProductNameEn) {
            columns.push(createColumnInput({
                title: () => i18n.global.t("model.product.name"),
                dataIndex: "refSamplingProduct.refCompanyProduct.refProduct.nameEn",
                align: 'center',
                customRender: ({ record, column }) => checkTooltipLabel({ field: column,  labelTitle: record.refSamplingProduct?.refCompanyProduct?.refProduct?.nameEn, parentModel: record.refParent, model: record }),
            }))
        }
        if (visibleSamplingProductNameTh) {
            columns.push(createColumnInput({
                title: () => i18n.global.t("model.samplingProduct.samplingNameTh2"),
                dataIndex: "refSamplingProduct.samplingNameTh",
                align: 'center',
                customRender: ({ record, column }) => checkTooltipLabel({ field: column,  labelTitle: record.refSamplingProduct?.samplingNameTh, parentModel: record.refParent, model: record }),
            }))
        }
        if (visiblePackageSize) {
            columns.push(createColumnInput({
                title: () => i18n.global.t("model.samplingProduct.packageSize"),
                dataIndex: "refSamplingProduct.packageSize",
                align: 'center',
                customRender: ({ record, column }) => checkTooltipLabel({ field: column,  labelTitle: record.refSamplingProduct?.packageSize, parentModel: record.refParent, model: record }),
            }))
        }
        if (visibleExportAmount) {
            if(isTablePackaging) {
                //export_amount from t_certificate_product
                columns.push(
                    createColumnInlineInputNumber({
                            visible: () => true,
                            title: () => i18n.global.t("model.samplingProduct.exportAmount"),
                            dataIndex: "exportAmount",
                            items,
                            useForm,
                            itemsKey,
                            customRenderInputProp: ({ record, column }) => ({
                                disabled: viewOnly,
                                prefix: () => checkTooltipLabel({ field: column,  labelTitle: "", parentModel: record.refParent, model: record }),
                                suffix: record.refSamplingProduct?.refExportAmountUnit?.value,
                                'onUpdate:value': () => {
                                    let totalExportAmount = 0
                                    modelRef.certificateProducts.forEach(item => {
                                        const exportAmount = parseInt(item.exportAmount || 0)
                                        totalExportAmount += exportAmount
                                    })
                                    modelRef.qty = totalExportAmount
                                }
                            })
                    })
                )
            } else {
                //export_amount from t_sampling_product
                columns.push(createColumnInput({
                    title: () => i18n.global.t("model.samplingProduct.exportAmount"),
                    dataIndex: "refSamplingProduct.exportAmount",
                    align: 'center',
                    customRender: ({ record, column }) => checkTooltipLabel({
                        field: column,
                        labelTitle: record.refSamplingProduct?.exportAmount,
                        parentModel: record.refParent,
                        model: record, textSuffix:
                        record.refSamplingProduct?.refExportAmountUnit?.value
                    }),
                }))
            }
        }
        if (visibleBalanceAmount) {
            columns.push(createColumnInput({
                title: () => i18n.global.t("model.certificateRequest.balanceAmount"),
                dataIndex: "refSamplingProduct.balanceAmount",
                align: 'center',
                customRender: ({ record, column }) => {
                    return checkTooltipLabel({
                        field: column,
                        labelTitle: record.balanceAmount,
                        parentModel: record.refParent,
                        model: record,
                        textSuffix: record.refSamplingProduct?.refExportAmountUnit?.value
                    })
                },
                sorter: false,
                search: {
                    visible: () => false
                }
            }))
        }
        if (visibleExportCountry) {
            columns.push(
                createColumnSelect({
                    title: () => i18n.global.t("model.samplingProduct.refCompanyCountry1"),
                    dataIndex: 'refCompanyCountry1.refCountry.id',
                    inputProp: () => ({
                        list: ({ searchQuery }) => store.dispatch('resource/v1/master/country/cacheFindAll', { nameTh: searchQuery, nameEn: searchQuery }),
                        renderLabel: ({ item }) => <div>{item.nameTh} ({item.nameEn})</div>,
                    }),
                    customRender: ({ record, column }) => checkTooltipLabel({ field: column,  labelTitle: record.refSamplingProduct?.refCountry1?.nameEn, parentModel: record.refParent, model: record }),
                    align: "center",
                })
            )
            columns.push(
                createColumnSelect({
                    title: () => i18n.global.t("model.samplingProduct.refCompanyCountry2"),
                    dataIndex: 'refCompanyCountry2.refCountry.id',
                    inputProp: () => ({
                        list: ({ searchQuery }) => store.dispatch('resource/v1/master/country/cacheFindAll', { nameTh: searchQuery, nameEn: searchQuery }),
                        renderLabel: ({ item }) => <div>{item.nameTh} ({item.nameEn})</div>,
                    }),
                    align: "center",
                    customRender: ({ record, column }) => checkTooltipLabel({ field: column,  labelTitle: record.refSamplingProduct?.refCountry2?.nameEn, parentModel: record.refParent, model: record }),

                })
            )
        }
    }
    if (visibleCompanyProducts) {
        if (visibleProductCode) {
            columns.push(createColumnInput({
                title: () => i18n.global.t("model.product.code"),
                dataIndex: "refCompanyProduct.refProduct.code",
                align: 'center',
                customRender: ({ record, column }) => checkTooltipLabel({ field: column,  labelTitle: record.refCompanyProduct?.refProduct?.code, parentModel: record.refParent, model: record }),
            }))
        }
        if (visibleProductNameEn) {
            columns.push(createColumnInput({
                title: () => i18n.global.t("model.product.name"),
                dataIndex: "refCompanyProduct.refProduct.nameEn",
                align: 'center',
                customRender: ({ record, column }) => checkTooltipLabel({ field: column, labelTitle: record.refCompanyProduct?.refProduct?.nameEn, parentModel: record.refParent, model: record }),
            }))
        }
    }
    return columns
}

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error })
            throw error
        });
}

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visibleCompanyProducts, visibleSamplingProducts, isTablePackaging, isTmp, canAddProduct } = props
    const { useForm } = data
    const { modelRef } = useForm
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef

    data.columns = createColumns({ props, data })
    data.page = createPage({ data: items }) // value = ???
    data.tableOptions = { search: { activeKey: null } }
    if (!isTablePackaging) {
        data.manages = [
            createManageDelete({
                menuContext,
                visible: () => viewOnly ? false : has({ menuContext, key: 'canDelete' }),
                onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey }),
            }),
            createManageExportCsv({ menuContext }),
        ]
    }
    data.manageExtras = []
    data.rowActions = []

    if (!viewOnly) {
        if (visibleCompanyProducts) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => {
                            useForm.validate(['refExportCountry']).then(() => {
                                openModalListCompanyProduct({
                                    onIframeMounted: ({ refs, options }) => {
                                        onIFrameClickSelectAll({
                                            refs, options, items, itemKey: 'refCompanyProduct.id', rowKey: 'id', setKey: 'refCompanyProduct',
                                            // afterSelect: () => {
                                            //     modelRef.commodityName = modelRef.certificateProducts.map(d => d.refCompanyProduct?.refProduct?.nameEn).join(", ")
                                            // },
                                            onSearch: ({ page }) => {
                                                page.where.push({name: 'refCompany.id', type: 'UUID', operator: '=', value: modelRef.refCompany.id})
                                                page.where.push({ name: 'isActive', type: 'Boolean', operator: '=', value: true })
                                                page.where.push({ logic: 'AND', name: 'refSamplingCondition.key', type: 'String', operator: '=', value: 'S' })
                                                page.where.push({ logic: 'AND', name: 'refStatus.key', type: 'String', operator: '=', value: "Approve" })
                                                page.where.push({ logic: 'AND', name: 'isSuspendedHc', type: 'Boolean', isNot: true, operator: '=', value: true })

                                                let productTypeKey = 'refCompanyProduct.refProduct.refProductType.key'
                                                const value = items.filter(d => d.isDelete !== true).map(d => lodash.get(d, 'refCompanyProduct.id'))
                                                const valueProductType = items.filter(d => d.isDelete !== true).map(d => lodash.get(d, productTypeKey))
                                                if (value.length > 0) {
                                                    page.where.push({ name: 'id', type: 'UUID', isNot: true, operator: 'in', value })
                                                    page.where.push({ logic: 'AND', name: 'refProduct.refProductType.key', type: 'String', operator: '=', value: valueProductType[0] })
                                                }
                                            }
                                        })
                                        if(!modelRef.certificateProducts?.length) {
                                            refs.iframe.contentWindow.selectType = 'radio'
                                        }
                                    },
                                })
                            }).catch((error) => {
                                validateError({ error })
                                throw error
                            })
                        },
                        options: { text: i18n.global.t('model.companyProduct.refProduct') }
                    }),
                }),
                visible: () => has({ menuContext, key: 'canCreate' }) && !isTmp,
            })
        }

        if (visibleSamplingProducts) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => {
                            useForm.validate(['refExportCountry']).then(() => {
                                openModalListSamplingProduct({
                                    onIframeMounted: ({ refs, options }) => {
                                        onIFrameClickSelectAll({
                                            refs,
                                            options,
                                            items,
                                            itemKey: 'refSamplingProduct.id',
                                            rowKey: 'id',
                                            setKey: 'refSamplingProduct',
                                            afterSelect: ({ rowSelection }) => {
                                                modelRef.refExportAmountUnit = modelRef?.certificateProducts?.length > 0 ? modelRef?.certificateProducts?.map(d => d?.refSamplingProduct?.refExportAmountUnit)?.[0] : rowSelection?.selectedRows?.[0].refExportAmountUnit
                                                // modelRef.commodityName = modelRef.certificateProducts.map(d => d.refSamplingProduct?.refCompanyProduct?.refProduct?.nameEn).join(", ")
                                                if (!modelRef?.refRequestStatus?.key || modelRef?.refRequestStatus?.key === "Draft") {
                                                    const { selectedRows } = rowSelection;
                                                    const sumExportAmountModels = selectedRows.map(d=>{
                                                        const samplingProductId = d.id;
                                                        const certificateProductId = modelRef.certificateProducts?.find(cp=>cp.refSamplingProduct?.id === samplingProductId)?.id;
                                                        return { certificateProductId, samplingProductId, samplingProductExportAmount: d.exportAmount || 0 }
                                                    });
                                                    sumExportAmountModels.forEach(d => {
                                                        callGetSumExportAmount(d).then((res) => {
                                                            const samplingProductId = res.samplingProductId;
                                                            const index = modelRef.certificateProducts?.findIndex(cp=>cp.refSamplingProduct?.id === samplingProductId);
                                                            const certificateProduct = lodash.cloneDeep(modelRef.certificateProducts[index]);
                                                            const exported = res.sum || 0;
                                                            certificateProduct.balanceAmount = d.samplingProductExportAmount - exported;
                                                            modelRef.certificateProducts.splice(index, 1)
                                                            modelRef.certificateProducts.splice(index, 0, certificateProduct)
                                                        });
                                                    })
                                                }
                                            },
                                            onSearch: ({ page }) => {
                                                //เช็ค เช็คลูก companyCountry1.refCompany.children.id = refExportCountry.id
                                                let country = [modelRef.refExportCountry.id]
                                                modelRef.refExportCountry.refParent ? country.push(modelRef.refExportCountry.refParent.id) : ""

                                                page.where.push({ openBucket: true, name: 'refCountry1.id', type: 'UUID', operator: 'in', value: country })
                                                page.where.push({ logic: 'OR', name: 'refCountry1.refParent.id', type: 'UUID', operator: 'in', value: country })
                                                page.where.push({ logic: 'OR', name: 'refCountry2.id', type: 'UUID', operator: 'in', value: country })
                                                page.where.push({ closeBucket: true, logic: 'OR', name: 'refCountry2.refParent.id', type: 'UUID', operator: 'in', value: country })
                                                page.where.push({ name: 'refAcceptanceStatus.key', type: 'String', operator: '=', value: "Accept" })
                                                page.where.push({ name: 'refStatus.key', type: 'String', operator: '=', value: "Send Result" })
                                                page.where.push({ name: 'isActive', type: 'Boolean', operator: '=', value: true })
                                                page.where.push({ name: 'refSamplingRequest.refSamplingStatus.key', type: 'String', operator: '=', value: "Done" })
                                                page.where.push({ name: 'refSamplingRequest.refSamplingRequestType.key', type: 'String', operator: '=', value: "L" })

                                                let productTypeKey = 'refSamplingProduct.refCompanyProduct.refProduct.refProductType.key'
                                                const value = items.filter(d => d.isDelete !== true).map(d => lodash.get(d, 'refSamplingProduct.id'))
                                                const valueProductType = items.filter(d => d.isDelete !== true).map(d => lodash.get(d, productTypeKey))
                                                if (value.length > 0) {
                                                    page.where.push({ name: 'id', type: 'UUID', isNot: true, operator: 'in', value })
                                                    page.where.push({ logic: 'AND', name: 'refCompanyProduct.refProduct.refProductType.key', type: 'String', operator: '=', value: valueProductType[0] })
                                                }
                                            },
                                        })
                                        if(!modelRef.certificateProducts?.length) {
                                            refs.iframe.contentWindow.selectType = 'radio'
                                        }
                                    },
                                    isNotVisibleCreate: true
                                })
                            }).catch((error) => {
                                validateError({ error })
                                throw error
                            })
                        },
                        options: { text: i18n.global.t('model.companyProduct.refProduct') }
                    }),
                }),
                visible: () => has({ menuContext, key: 'canCreate' }) && !isTmp && canAddProduct,
            })
        }
    }
}